<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == 'ven-pacote-kit') {
            next({ name: 'ven-pacote-kit-list' });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == 'ven-pacote-kit') {
            this.$router.push({ name: 'ven-pacote-kit-list' });
        }
    },
};
</script>
